import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('bringozDuration', bringozDuration);

function bringozDuration(moment) {
  return function bringozDurationFilter(time, unit?) {
    const defaultUnit = 'milliseconds'
    const data = moment.duration(time, unit || defaultUnit)._data;

    if (data.days) {
      return data.days + 'days ' + data.hours + 'hr';
    }
    if (data.hours) {
      return data.hours + 'hr ' + data.minutes + 'min';
    }
    if (data.minutes) {
      return data.minutes + 'min';
    } else {
      return moment.duration(time, 'seconds').humanize();
    }
  }
}
